export default __webpack_public_path__ + "static/media/Hector2.f24af5fe.png";